// extracted by mini-css-extract-plugin
export default {"scrollerRoot":"scrollerRoot__fOz9QBTkAiMI","hidden":"hidden__b7XMlDngmDgD"};